export default __webpack_public_path__ + "static/blueberry-3be7914185bdd108eca777e29f819164.png";